<template>
  <div id="content-wrapper">
    <b-tabs content-class="mt-3">
      <b-tab
        :active="!activeTab || activeTab === `#${VAI_TRO_TAB.THONG_TIN_VAI_TRO}`"
        @click="changeCurrentTab(VAI_TRO_TAB.THONG_TIN_VAI_TRO)"
        title="Thông tin vai trò"
      >
        <div class="box box-form pb-5">
          <FormVaiTro
            :form="chiTietVaiTro"
            ref="cap-nhat-vai-tro"
            :danh-sach-app="danhSachApp"
          />
          <div class="d-flex float-right">
            <base-button
              @click="capNhatVaiTro()"
              class="btn btn-main ml-2"
              :disabled="isLoading"
              button="Lưu"
              v-if="this.$route.params.id !== 'tao-moi'"
            >
              Cập nhật
            </base-button>

            <base-button
              v-if="this.$route.params.id === 'tao-moi'"
              @click="taoMoiVaiTro()"
              class="btn btn-main ml-2"
              button="Lưu"
              :disabled="isLoading"
              color="btn-success"
            >
              Lưu
            </base-button>
            <base-button
              @click="lamMoi()"
              class="btn btn-main ml-2"
              button="Làm mới"
              color="btn-warning"
            >
              Làm mới
            </base-button>
            <base-button button="Đóng" @click="boQua()" class="btn btn-line">
              Đóng
            </base-button>
          </div>
        </div>
      </b-tab>
      <b-tab
        :active="activeTab === `#${VAI_TRO_TAB.NGUOI_DUNG}`"
        @click="changeCurrentTab(VAI_TRO_TAB.NGUOI_DUNG)"
        title="Người dùng"
        v-if="!(disabledItem && this.$route.params.id === 'tao-moi')"
      >
        <div class="box box-form">
          <DanhSachNguoiDungTheoVaiTro
            :chiTietVaiTro="chiTietVaiTro"
            :key="`thuoc-vai-tro-${
              chiTietVaiTro && chiTietVaiTro.role && chiTietVaiTro.role.id
            }`"
            ref="danhSachNguoiDungTheoVaiTro"
          />
        </div>
      </b-tab>
      <b-tab
        :active="activeTab === `#${VAI_TRO_TAB.QUYEN}`"
        @click="changeCurrentTab(VAI_TRO_TAB.QUYEN)"
        title="Phân quyền"
        v-if="!(disabledItem && this.$route.params.id === 'tao-moi')"
      >
        <div class="box box-form">
          <div class="row">
            <div class="col-md-6 col-xs-12">
              <b-form-group
                label="Ứng dụng"
                label-for="ung-dung"
                label-class="font-weight-bold font-size-16"
              >
                <v-select
                  :options="danhSachAppNoiBo"
                  id="id"
                  label="name"
                  :reduce="(app) => app.id"
                  v-model="internalAppId"
                  :readonly="true"
                  placeholder="Chọn ứng dụng"
                >
                  <span slot="no-options">
                    Không tìm thấy dữ liệu
                  </span></v-select
                >
              </b-form-group>
            </div>
            <div class="col-md-8 col-xs-12"></div>
          </div>
          <DanhSachQuyenTrongVaiTro
            :chiTietNguoiDung="chiTietVaiTro"
            :appId="internalAppId"
            :key="`danh-sach-quyen-${
              chiTietVaiTro && chiTietVaiTro.role && chiTietVaiTro.role.id
            }`"
            ref="danhSachQuyenTrongVaiTro"
          />
        </div>
      </b-tab>
    </b-tabs>
  </div>
</template>

<script>
import {
  BO_QUA_BUTTON_LABEL,
  ROUTE_NAME,
  VAI_TRO_TAB,
} from "@/constants/constants";
import {
  TAO_VAI_TRO_THANH_CONG,
  THONG_TIN_VAI_TRO_DUOC_CAP_NHAT_THANH_CONG,
} from "@/constants/message";
import FormVaiTro from "@/components/pages/quan-tri-he-thong/vai-tro/FormVaiTro";
import DanhSachNguoiDungTheoVaiTro from "@/components/pages/quan-tri-he-thong/nguoi-dung/DanhSachNguoiDungTheoVaiTro";
import DanhSachQuyenTrongVaiTro from "@/components/pages/quan-tri-he-thong/quyen/DanhSachQuyenTrongVaiTro";
import { mapGetters } from "vuex";

export default {
  name: "CapNhatVaiTro",
  data() {
    return {
      BO_QUA_BUTTON_LABEL: BO_QUA_BUTTON_LABEL,
      internalChiTietVaiTro: {},
      activeTab: "#thong-tin-nhom",
      VAI_TRO_TAB: VAI_TRO_TAB,
      disabledItem: true,
      isLoading: false,
      internalAppId: null,
    };
  },
  components: {
    FormVaiTro,
    DanhSachNguoiDungTheoVaiTro,
    DanhSachQuyenTrongVaiTro,
  },
  computed: {
    ...mapGetters({
      chiTietVaiTro: "role/chiTietVaiTro",
      danhSachApp: "app/tatCaApp",
    }),
    danhSachAppNoiBo() {
      if (
        this.danhSachApp &&
        this.chiTietVaiTro &&
        this.chiTietVaiTro.applicationIds
      ) {
        return this.danhSachApp.filter((x) =>
          this.chiTietVaiTro.applicationIds.includes(x.id)
        );
      } else {
        return [];
      }
    },
  },
  created() {
    this.activeTab = location.hash;
    if (this.$route.params.id !== "tao-moi") {
      this.getChiTiet()
    }
    this.layDanhSachApp();
  },
  watch: {
    chiTietVaiTro: {
      handler() {
        this.internalChiTietVaiTro = Object.assign(
          {},
          this.internalChiTietVaiTro,
          this.chiTietVaiTro
        );
        if (
          this.chiTietVaiTro.applicationIds &&
          this.chiTietVaiTro.applicationIds.length === 1
        ) {
          this.internalAppId = this.chiTietVaiTro.applicationIds[0];
        }
      },
    },
  },
  methods: {
    getChiTiet () {
      this.$store.dispatch("role/layChiTietVaiTro", {
        id: this.$router.currentRoute.params.id,
      });
    },
    lamMoi() {
      if (this.$route.params.id == "tao-moi") {
        this.$refs["cap-nhat-vai-tro"].lamMoi();
      } else {
        this.getChiTiet()
      }
    },
    async taoMoiVaiTro() {
      const isValid = await this.$refs[
        "cap-nhat-vai-tro"
      ].$refs.observer.validate();
      const $vm = this;
      this.disabledItem = true;
      if (isValid) {
        this.isLoading = true
        this.$store
          .dispatch(
            "role/taoVaiTro",
            this.$refs["cap-nhat-vai-tro"].getInternalForm()
          )
          .then((response) => {
            if (response.data.succeeded) {
              this.disabledItem = false;
              $vm.$toasted.clear();
              $vm.$toasted.global.showSuccessMessage({
                message: TAO_VAI_TRO_THANH_CONG,
              });
              this.$router.push({
                params: { id: response.data.data },
              });
              this.$store.dispatch("role/layChiTietVaiTro", {
                id: response.data.data,
              });
            }
            this.isLoading = false
          })
          .catch((err) => {
            this.$toasted.clear();
            this.$toasted.global.showErrorMessage({
              message: err.data.message,
            });
            this.isLoading = false
          });
      }
    },
    layDanhSachApp() {
      this.$store.dispatch("app/layTatCaApp");
    },
    changeCurrentTab(currentTab) {
      this.$router
        .push({
          name: ROUTE_NAME.QUAN_TRI_HE_THONG.CAP_NHAT_VAI_TRO,
          hash: `#${currentTab}`,
        })
        .catch(() => {});
      this.internalAppId = null  
      this.getChiTiet()  
    },
    boQua() {
      this.$router.push({
        name: ROUTE_NAME.QUAN_TRI_HE_THONG.VAI_TRO,
      });
    },
    async capNhatVaiTro() {
      const isValid = await this.$refs[
        "cap-nhat-vai-tro"
      ].$refs.observer.validate();
      const $vm = this;
      this.disabledItem = true;
      if (isValid) {
        this.isLoading = true
        this.$store
          .dispatch(
            "role/capNhatThongTinVaiTro",
            this.$refs["cap-nhat-vai-tro"].getInternalForm()
          )
          .then((response) => {
            if (response.data.succeeded) {
              this.disabledItem = false;
              $vm.$toasted.clear();
              $vm.$toasted.global.showSuccessMessage({
                message: THONG_TIN_VAI_TRO_DUOC_CAP_NHAT_THANH_CONG,
              });
              this.$store.dispatch("role/layChiTietVaiTro", {
                id: this.$router.currentRoute.params.id,
              });
            }
            this.isLoading = false
          })
          .catch((err) => {
            this.$toasted.clear();
            this.$toasted.global.showErrorMessage({
              message: err.data.message,
            });
            this.isLoading = false
          });
      }
    },
  },
};
</script>


